// noinspection DuplicatedCode
import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import Card from "@material-tailwind/react/Card";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";

import { isRequired, useForm } from "../../../../components/isRequired";
import Loading from "../../../../components/loading/Loading";
import Skeltons from "../../../../components/loading/Skeltons";
import { Colors } from "../../../../assets/Colors";
import { KaryawanSelectorBuilder } from "../../karyawan/KaryawanSelector";

import {
  getKontrakKerjaTransaksi,
  insertKontrakKerjaTransaksi,
  updateKontrakKerjaTransaksi,
  deleteKontrakKerjaTransaksi,
  getSpecKontrakKerja,
  kontrakKerjaTransaksiSelector,
} from "./kontrakKerjaTransaksiSlice";
import { approve } from "../../../setup/approval/approvalSlice";
import {
  getMinTipeKaryawan,
  tipeKaryawanSelector,
} from "../../../master/tipe-karyawan/tipeKaryawanSlice";

const toDateInputStr = (d) =>
  d instanceof Date && !isNaN(d.getTime())
    ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
        d.getDate()
      ).padStart(2, "0")}`
    : "";

const KontrakKerjaPage = () => {
  const initialState = {
    Nik: "",
    TipeKaryawanID: "",
    NomorKontrak: "",
    Keterangan: "",
  };
  const validations = [
    ({ Nik }) => isRequired(Nik) || { Nik: "Karyawan wajib dipilih" },
    ({ TipeKaryawanID }) =>
      isRequired(TipeKaryawanID) || { TipeKaryawanID: "Tipe karyawan wajib dipilih" },
  ];
  const { values, errors, touched, changeHandler, customHandler, editHandler, clearHandler } =
    useForm(initialState, validations);
  const [buttonTouched, setButtonTouched] = useState(false);

  const dispatch = useDispatch();
  const kontrakKerja = useSelector(kontrakKerjaTransaksiSelector);
  const tipeKaryawan = useSelector(tipeKaryawanSelector);

  const [tanggalMulai, setTanggalMulai] = useState("");
  const [tanggalBerakhir, setTanggalBerakhir] = useState("");
  const [isValidTanggal, setIsValidTanggal] = useState(true);
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [currentData, setCurrentData] = useState({});
  const [showModalDetail, setShowModalDetail] = useState(false);
  const [detailID, setDetailID] = useState("");
  const [detailRow, setDetailRow] = useState({});

  const refetchList = (searchValue = searchQuery) =>
    dispatch(getKontrakKerjaTransaksi({ start: 0, count: 200, search: searchValue }));

  useEffect(() => {
    refetchList("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── Data list (client-side search + pagination, mengikuti pola Promosi/Lembur) ──
  const allRows = useMemo(
    () => (Array.isArray(kontrakKerja.data) ? kontrakKerja.data : []),
    [kontrakKerja.data]
  );
  const PAGE_SIZE = 10;
  const totalPage = Math.max(1, Math.ceil(allRows.length / PAGE_SIZE));
  const safePage = Math.min(page, totalPage);
  const pageRows = useMemo(() => {
    const s = (safePage - 1) * PAGE_SIZE;
    return allRows.slice(s, s + PAGE_SIZE);
  }, [allRows, safePage]);

  const openTambah = () => {
    clearHandler();
    setTanggalMulai("");
    setTanggalBerakhir("");
    setIsValidTanggal(true);
    setButtonTouched(false);
    setCurrentData({});
    setShowModalEdit(false);
    setShowModalAdd(true);
    dispatch(getMinTipeKaryawan({ search: "" }));
  };
  const openEdit = (row) => {
    clearHandler();
    editHandler({
      Nik: row.Nik,
      TipeKaryawanID: row.TipeKaryawanID,
      NomorKontrak: row.NomorKontrak,
      Keterangan: row.Keterangan,
    });
    setTanggalMulai(row.TanggalMulai ? new Date(row.TanggalMulai) : "");
    setTanggalBerakhir(row.TanggalBerakhir ? new Date(row.TanggalBerakhir) : "");
    setCurrentData(row);
    setShowModalEdit(true);
    setShowModalAdd(true);
    dispatch(getMinTipeKaryawan({ search: "" }));
  };
  const closeModal = () => {
    setShowModalAdd(false);
    setShowModalEdit(false);
    clearHandler();
    setTanggalMulai("");
    setTanggalBerakhir("");
    setButtonTouched(false);
  };

  const submit = () => {
    setButtonTouched(true);
    if (!values.Nik || !values.TipeKaryawanID) return;
    if (!tanggalMulai) {
      setIsValidTanggal(false);
      return;
    }
    const payload = {
      Nik: values.Nik,
      TipeKaryawanID: values.TipeKaryawanID,
      NomorKontrak: values.NomorKontrak,
      TanggalMulai: toDateInputStr(tanggalMulai),
      TanggalBerakhir: toDateInputStr(tanggalBerakhir),
      Keterangan: values.Keterangan,
    };
    if (showModalEdit) {
      dispatch(
        updateKontrakKerjaTransaksi({ ...payload, TKontrakKerjaID: currentData.TKontrakKerjaID })
      ).then((res) => {
        if (!res.error) {
          toast.success("Data diperbarui", { position: "bottom-right", autoClose: 3000 });
          closeModal();
          refetchList();
        } else {
          toast.error(res.payload?.message || "Gagal memperbarui data", {
            position: "bottom-right",
          });
        }
      });
    } else {
      dispatch(insertKontrakKerjaTransaksi(payload)).then((res) => {
        if (!res.error) {
          toast.success("Pengajuan dibuat", { position: "bottom-right", autoClose: 3000 });
          closeModal();
          refetchList();
        } else {
          toast.error(res.payload?.message || "Gagal membuat pengajuan", {
            position: "bottom-right",
          });
        }
      });
    }
  };

  const doSend = async (row) => {
    try {
      const res = await dispatch(approve({ primary: row.TKontrakKerjaID })).unwrap();
      if (res && res.data === "Berhasil") {
        toast.success("Dikirim untuk approval", { position: "bottom-right", autoClose: 3000 });
      } else {
        toast.error((res && res.message) || "Gagal mengirim", { position: "bottom-right" });
      }
    } catch (e) {
      toast.error((e && e.message) || "Gagal mengirim untuk approval", {
        position: "bottom-right",
      });
    }
    refetchList();
  };
  const doDetail = (row) => {
    setDetailID(row.TKontrakKerjaID);
    setDetailRow(row);
    dispatch(getSpecKontrakKerja({ TransaksiApprovalID: row.TKontrakKerjaID }));
    setShowModalDetail(true);
  };
  const doDelete = (row) => {
    if (!window.confirm(`Hapus pengajuan ${row.TKontrakKerjaID} (${row.NamaKaryawan})?`)) return;
    dispatch(deleteKontrakKerjaTransaksi({ TKontrakKerjaID: row.TKontrakKerjaID })).then((res) => {
      if (!res.error) {
        toast.success("Data dihapus", { position: "bottom-right", autoClose: 3000 });
        refetchList();
      } else {
        toast.error(res.payload?.message || "Gagal menghapus", { position: "bottom-right" });
      }
    });
  };

  const statusClass = (s) =>
    s === "Selesai"
      ? "bg-green-100 text-green-800"
      : s === "Belum Dikirim"
      ? "bg-gray-100 text-gray-700"
      : s === "Ditolak"
      ? "bg-red-100 text-red-800"
      : "bg-yellow-100 text-yellow-800";

  const colHeader = [
    "ID",
    "Nama Karyawan",
    "Tipe Baru",
    "No. Kontrak",
    "Mulai",
    "Berakhir",
    "Status",
    "Aksi",
  ];

  return (
    <>
      <div className="md:ml-64">
        <div style={{ background: Colors.primary }} className="pt-14 pb-16 px-3 md:px-8 h-auto">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>
        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <Card>
                {kontrakKerja.isGetFetching ? (
                  <div className="w-full pt-0">
                    <Skeltons />
                  </div>
                ) : (
                  <>
                    <div className="flex w-full justify-between px-4 pt-4 flex-col sm:flex-row gap-2">
                      <button
                        onClick={openTambah}
                        className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                      >
                        Tambah +
                      </button>
                      <div className="flex flex-row w-96">
                        <input
                          type="text"
                          placeholder="Cari ID / Nama karyawan"
                          value={searchQuery}
                          onChange={(e) => {
                            setSearchQuery(e.target.value);
                            setPage(1);
                          }}
                          className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                        />
                      </div>
                    </div>

                    <div className="overflow-x-auto px-4 pt-4">
                      <table className="table-auto w-full text-sm text-left text-gray-500">
                        <thead className="text-xs text-orange-600 uppercase bg-gray-50">
                          <tr>
                            {colHeader.map((h, i) => (
                              <th key={i} className="py-3 px-6">
                                {h}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {pageRows.length === 0 ? (
                            <tr>
                              <td colSpan={colHeader.length} className="text-center py-8 text-gray-400">
                                Belum ada data kontrak kerja
                              </td>
                            </tr>
                          ) : (
                            pageRows
                              .filter((r) =>
                                searchQuery
                                  ? (r.TKontrakKerjaID + r.NamaKaryawan)
                                      .toLowerCase()
                                      .includes(searchQuery.toLowerCase())
                                  : true
                              )
                              .map((row, i) => {
                                const isDraft = String(row.Status) === "-1";
                                return (
                                  <tr
                                    key={row.TKontrakKerjaID}
                                    className={i % 2 === 0 ? "bg-gray-50 border-b" : "bg-white border-b"}
                                  >
                                    <td className="py-4 px-6 font-mono text-xs">
                                      {row.TKontrakKerjaID}
                                    </td>
                                    <td className="py-4 px-6">{row.NamaKaryawan}</td>
                                    <td className="py-4 px-6">{row.NamaTipeKaryawan || "-"}</td>
                                    <td className="py-4 px-6">{row.NomorKontrak || "-"}</td>
                                    <td className="py-4 px-6 whitespace-nowrap">
                                      {row.TanggalMulai || "-"}
                                    </td>
                                    <td className="py-4 px-6 whitespace-nowrap">
                                      {row.TanggalBerakhir || "Tanpa batas"}
                                      {row.AkanBerakhir && (
                                        <div className="text-xs font-semibold text-amber-600 mt-1">
                                          ⚠ {row.SisaHari} hari lagi
                                        </div>
                                      )}
                                    </td>
                                    <td className="py-4 px-6">
                                      <span
                                        className={`px-2 py-1 rounded-full text-xs font-semibold ${statusClass(
                                          row.StatusKet
                                        )}`}
                                      >
                                        {row.StatusKet}
                                      </span>
                                    </td>
                                    <td className="py-4 px-6 whitespace-nowrap">
                                      <div className="flex gap-2">
                                        {isDraft && (
                                          <>
                                            <button
                                              onClick={() => openEdit(row)}
                                              className="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-3 border border-gray-400 rounded shadow text-sm"
                                            >
                                              Edit
                                            </button>
                                            <button
                                              onClick={() => doSend(row)}
                                              className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-1 px-3 rounded shadow text-sm"
                                            >
                                              Kirim
                                            </button>
                                            <button
                                              onClick={() => doDelete(row)}
                                              className="bg-white hover:bg-red-50 text-red-600 font-semibold py-1 px-3 border border-red-300 rounded shadow text-sm"
                                            >
                                              Hapus
                                            </button>
                                          </>
                                        )}
                                        {!isDraft && (
                                          <button
                                            onClick={() => doDetail(row)}
                                            className="bg-white hover:bg-blue-50 text-blue-600 font-semibold py-1 px-3 border border-blue-300 rounded shadow text-sm"
                                          >
                                            Detail
                                          </button>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="flex flex-row justify-between items-center gap-4 px-4 py-4 text-sm text-gray-600">
                      <span>{allRows.length} data</span>
                      <div className="flex items-center gap-4">
                        <button
                          onClick={() => setPage((p) => Math.max(1, p - 1))}
                          disabled={safePage <= 1}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100"
                        >
                          Prev
                        </button>
                        <span>
                          Page {safePage} / {totalPage}
                        </span>
                        <button
                          onClick={() => setPage((p) => Math.min(totalPage, p + 1))}
                          disabled={safePage >= totalPage}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </Card>
            </div>
          </div>
        </div>
      </div>

      {/* ── Modal Tambah/Edit ── */}
      <Modal size="regular" active={showModalAdd} toggler={() => setShowModalAdd(true)}>
        <ModalHeader className="mt-20" toggler={closeModal}>
          {showModalEdit ? "Edit Kontrak Kerja" : "Tambah Kontrak Kerja"}
        </ModalHeader>
        <ModalBody>
          <form className="w-full max-w-lg">
            <KaryawanSelectorBuilder value={values.Nik} onChange={customHandler} noTlpn />

            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Tipe Karyawan Baru *
                </label>
                <select
                  value={values.TipeKaryawanID}
                  onChange={(e) => customHandler(e.target.value, "TipeKaryawanID")}
                  className={
                    (touched.TipeKaryawanID || buttonTouched) && errors.TipeKaryawanID
                      ? "appearance-none block w-full text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                      : "appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                >
                  <option value="">-- Pilih --</option>
                  {(tipeKaryawan?.minData || []).map((o) => (
                    <option key={o.TipeKaryawanID} value={o.TipeKaryawanID}>
                      {o.NamaTipeKaryawan}
                    </option>
                  ))}
                </select>
                {(touched.TipeKaryawanID || buttonTouched) && errors.TipeKaryawanID && (
                  <p className="text-red-500 text-xs italic">{errors.TipeKaryawanID}</p>
                )}
              </div>
            </div>

            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Nomor Kontrak
                </label>
                <input
                  value={values.NomorKontrak}
                  onChange={changeHandler}
                  name="NomorKontrak"
                  type="text"
                  className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                />
              </div>
            </div>

            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full md:w-1/2 px-3">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Tanggal Mulai *
                </label>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={tanggalMulai || null}
                  onChange={(d) => {
                    setTanggalMulai(d);
                    setIsValidTanggal(true);
                  }}
                  className={
                    !isValidTanggal
                      ? "appearance-none block w-full text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight outline-none bg-white"
                      : "appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                  }
                />
                {!isValidTanggal && (
                  <p className="text-red-500 text-xs italic">Tanggal mulai wajib diisi</p>
                )}
              </div>
              <div className="w-full md:w-1/2 px-3">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Tanggal Berakhir
                </label>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  isClearable
                  placeholderText="Tanpa batas (mis. Tetap/PKWTT)"
                  selected={tanggalBerakhir || null}
                  onChange={(d) => setTanggalBerakhir(d)}
                  className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                />
              </div>
            </div>

            <div className="flex flex-wrap -mx-3 mb-2">
              <div className="w-full px-3">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                  Keterangan
                </label>
                <input
                  value={values.Keterangan}
                  onChange={changeHandler}
                  name="Keterangan"
                  type="text"
                  className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                />
              </div>
            </div>

            <div className="flex flex-wrap -mx-3 mb-2">
              <div className="w-full px-3 text-xs text-gray-500">
                Dokumen fisik (PDF/scan) kontrak diupload lewat halaman{" "}
                <span className="font-semibold">File Karyawan</span> (Jenis Dokumen: Kontrak
                Kerja) — bukan di form ini.
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button color="red" buttonType="link" onClick={closeModal} ripple="dark">
            Batal
          </Button>
          <Button color="green" onClick={submit} ripple="light">
            SIMPAN
          </Button>
        </ModalFooter>
      </Modal>

      {/* ── Modal Detail: snapshot lama + riwayat approval ── */}
      <Modal size="regular" active={showModalDetail} toggler={() => setShowModalDetail(true)}>
        <ModalHeader
          className="mt-20"
          toggler={() => {
            setShowModalDetail(false);
            setDetailID("");
          }}
        >
          Detail Kontrak Kerja
        </ModalHeader>
        <ModalBody>
          {kontrakKerja.SpecKontrakKerjaData &&
          kontrakKerja.SpecKontrakKerjaData.TKontrakKerjaID === detailID ? (
            <div className="w-full">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                <div>
                  <div className="text-xs font-bold uppercase text-gray-500">Nama Karyawan</div>
                  <div className="text-gray-800">{detailRow.NamaKaryawan || "-"}</div>
                </div>
                <div>
                  <div className="text-xs font-bold uppercase text-gray-500">Nomor Kontrak</div>
                  <div className="text-gray-800">
                    {kontrakKerja.SpecKontrakKerjaData.NomorKontrak || "-"}
                  </div>
                </div>
                <div>
                  <div className="text-xs font-bold uppercase text-gray-500">Tipe Lama → Baru</div>
                  <div className="text-gray-800">
                    {kontrakKerja.SpecKontrakKerjaData.NamaTipeLama || "-"} →{" "}
                    {kontrakKerja.SpecKontrakKerjaData.NamaTipeKaryawan || "-"}
                  </div>
                </div>
                <div>
                  <div className="text-xs font-bold uppercase text-gray-500">Mulai → Berakhir</div>
                  <div className="text-gray-800">
                    {kontrakKerja.SpecKontrakKerjaData.TanggalMulai || "-"} →{" "}
                    {kontrakKerja.SpecKontrakKerjaData.TanggalBerakhir || "Tanpa batas"}
                  </div>
                </div>
                <div>
                  <div className="text-xs font-bold uppercase text-gray-500">Status</div>
                  <div className="text-gray-800">
                    {kontrakKerja.SpecKontrakKerjaData.StatusKet || "-"}
                  </div>
                </div>
                <div className="sm:col-span-2">
                  <div className="text-xs font-bold uppercase text-gray-500">Keterangan</div>
                  <div className="text-gray-800">
                    {kontrakKerja.SpecKontrakKerjaData.Keterangan || "-"}
                  </div>
                </div>
              </div>

              <div className="border-t pt-3 mb-2 font-semibold text-gray-700">Riwayat Approval</div>
              {Array.isArray(kontrakKerja.SpecKontrakKerjaData.Approval) &&
              kontrakKerja.SpecKontrakKerjaData.Approval.length > 0 ? (
                <div className="space-y-2">
                  {kontrakKerja.SpecKontrakKerjaData.Approval.map((a, ai) => {
                    const badge =
                      a.Approve === "Ditolak"
                        ? "bg-red-100 text-red-800"
                        : a.Approve === "Sudah diApprove"
                        ? "bg-green-100 text-green-800"
                        : "bg-gray-100 text-gray-600";
                    return (
                      <div key={ai} className="border rounded px-4 py-3 flex flex-col gap-1">
                        <div className="flex items-center justify-between gap-2">
                          <span className="font-medium text-gray-800">
                            {a.NamaBagian} — {a.NamaJabatan}
                          </span>
                          <span
                            className={`px-2 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${badge}`}
                          >
                            {a.Approve}
                          </span>
                        </div>
                        {a.Approve !== "Belum diApprove" && a.TanggalApproved && (
                          <div className="text-xs text-gray-600">{a.TanggalApproved}</div>
                        )}
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="text-gray-400 text-sm py-2">Belum ada data approval.</div>
              )}
            </div>
          ) : (
            <div className="flex justify-center py-8">
              <Loading />
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="blueGray"
            buttonType="link"
            onClick={() => {
              setShowModalDetail(false);
              setDetailID("");
            }}
            ripple="dark"
          >
            Tutup
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default KontrakKerjaPage;
